import React from 'react'

type UseLineItemFulfilmentCustomerDetailsViewParams = {
  onRemoveCustomer: () => void
}

export const useLineItemFulfilmentCustomerDetailsView = ({
  onRemoveCustomer,
}: UseLineItemFulfilmentCustomerDetailsViewParams) => {
  const removedCustomerOnMouseDown = React.useRef(false)

  const handleRemoveCustomerMouseDown = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault()
      event.stopPropagation()
      removedCustomerOnMouseDown.current = true
      onRemoveCustomer()
    },
    [onRemoveCustomer]
  )

  const handleRemoveCustomerClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()

      if (removedCustomerOnMouseDown.current) {
        removedCustomerOnMouseDown.current = false
        return
      }

      onRemoveCustomer()
    },
    [onRemoveCustomer]
  )

  return {
    handleRemoveCustomerMouseDown,
    handleRemoveCustomerClick,
  }
}
